<template>
  <datatable :type="'workers'" :subType="'no_id'" :rowData="workers" :loadingMessage="loadingMessage" :noRowsMessage="noRowsMessage" :columns="columns"
             :paginationSize="50"></datatable>
</template>
<script>
import datatable from "datatables/datatable";

export default {
  name: "all_uk_ireland",
  components: {datatable},
  data() {
    return {
      workers: null,
      loadingMessage: 'Loading Workers...',
      noRowsMessage: 'No Workers Found',
      columns: [
        {headerName: 'Ref', width: 100, suppressSizeToFit: true, valueGetter: this.ref_vg, pinned: 'left'},
        {headerName: 'Name', minWidth: 225, maxWidth: 300, pinned: 'left', field: 'full_name'},
        // {headerName: 'Email', minWidth: 225, maxWidth: 300, field: 'email_address'},
        // {headerName: 'Mobile', width: 100, field: 'phone_number'},
        {headerName: 'Country of Birth', minWidth: 150, field: 'country_name'},
        {headerName: 'Proof of ID', minWidth: 150, field: ''},
        {headerName: 'Proof of Address', minWidth: 150, field: ''},
        {headerName: 'Working For', minWidth: 300, valueGetter: this.working_for_vg, cellStyle: {'white-space': 'pre-wrap'}},
        {headerName: 'Assigned', minWidth: 110, valueGetter: this.assigned_vg},
      ]
    }
  },
  mounted() {
    this.get_workers();
  },
  methods: {
    get_workers() {
      axios.get(this.crmApiPath + 'worker/compliance/uk_ireland').then(res => this.workers = res.data);
    },
    ref_vg(params) {
      return params.data.company_internal_finance_ref === null ? params.data.internal_finance_ref : params.data.company_internal_finance_ref;
    },
    working_for_vg(params) {
      // website login email
      if (Object.keys(params.data.worker.unique_company_assignments).length > 0) {
        let temp = '';
        for (let i = 0; i < Object.keys(params.data.worker.unique_company_assignments).length; i++) {
          if (i > 0) {
            temp += "\n";
          }
          temp += params.data.worker.unique_company_assignments[i].company_name;
        }
        return temp;
      }
    },
    assigned_vg(params) {
      return this.$options.filters.formatDateTime(params.data.created_at);
    }
  }
}
</script>

<style scoped>

</style>
